module.exports = __webpack_public_path__ + "img/listMode.dc4a78c4.svg";